import { useCallback, useContext, useState } from "react";
import {
  ClinicContext,
  ClinicContextData,
  ClinicShortCode,
} from "fe-web-components/clinicDataProvider/clinicProvider";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";
import { usePatient } from "../state/patientContext";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";

export type ClinicData = ClinicContextData;

export const useClinicShortCode = () => {
  // const saveCase = useSaveConversationAsCase();

  //TBD: currently stored in the state, but possibly would be better stored globally in the context
  const [state, setState] = useState<ClinicShortCode>({
    current: null,
    lastCreated: null,
    loading: false,
  });

  const { caseId, shareId } = usePatient();

  const clinicDao = useClinicContext();

  const { clinic } = useClinicData();

  const makeCodeForCurrentSession = useCallback(async () => {
    // Turn on loading
    setState((scd) => ({
      ...scd,
      loading: true,
      current: null,
    }));

    let shortCode = null;
    let idToUse = caseId || shareId;
    console.log(idToUse);
    try {
      if (!idToUse) {
        evt({
          category: CATEGORY.PATIENT_GENERAL,
          action: ACTION.ERROR,
          label: "missing case id",
        });
        return false;
      }
      // convert to short code
      shortCode = await clinicDao.makeClinicShortCode(clinic, idToUse);
      // set new values and turn off loading
      setState((scd) => ({
        ...scd,
        current: shortCode,
        loading: false,
        ...(shortCode ? { lastCreated: shortCode } : {}),
      }));
      return !!shortCode;
    } catch (e) {
      evt({
        category: CATEGORY.PATIENT_GENERAL,
        action: ACTION.ERROR,
        label: JSON.stringify(e || {}, null, 2),
      });
      console.log(e);
      return false;
    }
  }, [clinicDao, clinic, caseId, shareId]);

  return {
    clinicShortCode: state,
    makeCodeForCurrentSession,
  };
};

export const useClinicData = (): ClinicData => {
  const initialClinicContext = {
    clinic: null,
    isClinicMode: false,
    setClinicId: () =>
      console.warn(
        "useClinicData.setClinicId was called before initialization! ",
      ),
  };

  const contextData = useContext(ClinicContext) || initialClinicContext;
  return contextData;
};
